<template>
    <div>
<!--         <slot
            v-if="hasCustomPreviewStep"
            name="customPreview"
        ></slot>
        <div
            v-else
        > -->
            <div
                v-show="displayLoader"
                class="loading-preview preview-button stopping-loader"
            >
                <div class="generation-spinner">
                    <span
                        v-loading="true"
                        class="preview-spinner"
                    >
                    </span>
                </div>
                <p
                    class="loading-title"
                >
                    The preview is stopping
                </p>
                <p class="loading-wait">
                    This operation can take a few minutes, please wait until it’s over.
                </p>
            </div>
            <div
                class="preview-media-container"
                v-show="!displayLoader"
            >
                <div
                    class="preview-player-container"
                    @mouseover="mouseOver()"
                    @mouseleave="mouseNotOver()"
                    :class="{'show-overlay': mouseIsOver}"
                    v-show="isInStepper"
                >
                    <div
                        class="preview-player"
                        :class="{'show-banner': mouseIsOver && close}"
                    >

                        <p
                            class="previous-time-text"
                        >
                            This preview will still last <span>{{ remainingTime }}</span> seconds
                        </p>
                        <button
                            class="icon-close"
                            @click="closeBanner()"
                        >
                            <i class="ti-close" ></i>
                        </button>

                    </div>

                    <button
                        class="action-button-stop player-button"
                        :class="{'show-button': mouseIsOver}"
                        @click="cancelPreview()"
                    >
                        <img src="/static/icon/square.png">
                    </button>

                    <div
                        class="progress-bar"
                        :class="{'show-progress-bar': mouseIsOver}"
                    >
                        <button
                            class="stop-button"
                            @click="cancelPreview()"
                        >
                            <img src="/static/icon/stop.png">
                        </button>
                        <div class="progess-bar-color">
                            <div
                                class="blue-linear"
                                :style="{'width': `${widthProgress}%` }"
                            ></div>
                        </div>
                        <p class="time">-{{remainingTime}}</p>
                    </div>
                </div>
                <preview-audio
                    :audio="fetchedAudio"
                ></preview-audio>
            </div>
        <!-- </div> -->
    </div>
</template>

<script>
    import axios from 'axios';
    import PreviewStepMixin from '@/components/Mixins/preview-step-mixin.vue';
    import PreviewAudio from '@/components/Preview/PreviewAudio';
    export default{
        name: 'Preview',
        mixins: [PreviewStepMixin],
        components: {
            PreviewAudio,
        },
        props: {
            changeRequest:{
                type: Object
            }
        },
        data(){
            return{
                seconds: 0,
                fetchInterval: null,
                handlerCountDown: null,
                mouseIsOver: false,
                close: true,
                fetchedAudio: [],
                countDownDuration: 0
            };
        },
        computed:{
            remainingTime(){
                return this.formatSeconds(this.seconds);
            },
            widthProgress(){
                // valeur entre 0 et 100
                // 0 si this.seconds = countDownDuration
                // 100 si this.seconds = 0
                return (100 - 100 * this.seconds / this.countDownDuration);
            },
            displayLoader(){
                // Condition to display loader : countdown reached 0 or Stop request in progress
                if(this.seconds <= 0 && this.isInStepper){
                    return true;
                }
                if(this.changeRequest !== undefined){
                    return true;
                }
                // return mixin inherited value
                return this.showLoader;
            }
        },
        mounted(){
            if(!this.hasCustomPreviewStep){
                this.countDownDuration = this.getTimeDeltaInSeconds(new Date(this.preview.end_date));
                this.enableCountDown();
                /*
                    Browser are stopping Timeout and Interval when switching tab
                    for performances/resources issues.
                    So we need to listen to visibilitychange event manually and call
                    toggleCountDown method everytime document visibility changes.
                    (see comment above toggleCountDown()).
                */
                // if(this.isInStepper){
                document.addEventListener('visibilitychange', () => {}, false);
                // }

                this.fetchPreviewDataPeriodically(this.preview);
                this.watchModelStatus(this.preview, 'COMPLETED').then(()=>{
                    if(this.skipLastStep){
                        this.$emit('setToOriginalStep');
                    } else if(this.isInStepper){
                        this.changeStep(5);
                    } else {
                        this.$emit('reloadData');
                    }
                });
            }
        },
        beforeDestroy(){
            clearInterval(this.fetchInterval);
            this.disableCountDown();
        },
        methods:{
            getTimeDeltaInSeconds(endDatetime, startDatetime=null){
                if(startDatetime === null || startDatetime === undefined){
                    startDatetime = Date.now();
                }
                return Math.max(Math.floor((endDatetime - startDatetime) / 1000), 0);
            },
            enableCountDown(){
                this.updateRemainingSeconds();
                this.handlerCountDown = setTimeout(() => {
                    this.enableCountDown();
                }, 500);
            },
            disableCountDown(){
                clearTimeout(this.handlerCountDown);
            },
            updateRemainingSeconds(){
                this.seconds = this.getTimeDeltaInSeconds(new Date(this.preview.end_date));
            },
            mouseOver(){
                this.mouseIsOver = true;
            },
            mouseNotOver(){
                this.mouseIsOver = false;
            },
            closeBanner(){
                this.close = false;
            },
            formatSeconds(timeInSeconds){
                let minutes = Math.floor(timeInSeconds / 60);
                let seconds = timeInSeconds - minutes * 60;
                return `${minutes<10?'0':''}${minutes}:${seconds<10?'0':''}${seconds}`;
            },
            fetchPreviewDataPeriodically(preview){
                this.fetchInterval = setInterval(()=>{
                    axios.get(preview.pod_preview_proxy_url)
                    .then((response)=>{
                        this.fetchedAudio = response.data.audio_levels;
                        this.$emit('setPreviewData', response.data.thumbnail_url);
                    }).catch((e)=>{
                        console.log(e);
                    });
                }, 1000);
            },
            // /*
            //     toggleCountDown() is called when document visibility changes.
            //     When document is hidden the timeout started in the watcher on this.seconds and calling customCountDown() is stopped.
            //     When document is visible again we update this.seconds triggering the timeout in the watcher again and updating the countdown with the new value.
            // */
            // toggleCountDown(e){

            //     if(document.hidden){
            //         // clearTimeout(this.countDownTimeout);
            //     }else{
            //         // let now = Date.now();
            //         // let endDate = new Date(this.preview.end_date);
            //         // this.seconds = Math.round((endDate - now) / 1000) + 10; // We add 10s because of automation latency
            //         // this.seconds = this.seconds < 0 ?  0 : this.seconds;
            //         // this.widthProgress = 0;
            //     }
            // }
        },

    };
</script>

<style>
.stopping-loader{
    background-color: rgba(0, 0, 0, 0.8);
}
.preview-player-container{
    height: 100%;
    position: absolute;
    top: 0;
    width: 100%;
    overflow: hidden;
}
.show-overlay{
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0) 100%);
    opacity: 0.8;
}
.preview-player{
    height: 35px;
    width: 100%;
    color: #ffffff;
    padding-left: 10px;
    font-size: 12px;
    line-height: 14px;
    position: absolute;
    top: -35px;
    display: flex;
    align-items: center;
    background-color: #3F9EFF;
    transition: top  0.5s ease-out ;
}

.show-banner{
    top: 0;
    transition: top 0.5s ease-out ;
}

.player-link {
    color: #ffffff;
    font-size: 12px;
    margin: 0 3px;
    text-decoration: underline;

}

.progress-bar{
    position: absolute;
    bottom: -35px;
    height: 35px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    width: 100%;
    background-color: #333333BF;
    transition: bottom  1s ease-out;
}

.show-progress-bar{
    transition: bottom 1s ease-out;
    bottom: 0;
}

.progess-bar-color{
    height: 3px;
    border-radius: 2px;
    width: 100%;
    background-color: #DFDFDF;
}

.blue-linear{
    border-radius: 2px;
    width: 60%;
    background-color: #3F9FEE;
    height: 100%;
}

.blue-linear::after{
    content: '';
    width: 12px;
    height: 12px;
    background-color: #3F9FEE;
    border-radius: 50%;
    display: inline-block;
    position: relative;
    top: -6px;
    right: -50%;
}

.time{
    width: 90px;
}

.time, .previous-time-text{
    margin-bottom: 0;
}

.stop-button{
    border: none;
    background-color: transparent;
    width: 50px;
}

.icon-close {
    margin-left: auto;
    padding: 1rem;
    color: #ffffff;
    border: none;
    background-color: transparent;
}

.action-button-stop{
    height: 50px;
    width: 50px;
    border-radius: 50%;
    border: none;
    background-color: #FFFFFF;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 2rem;
}

.player-button{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50% , -50%);
    opacity: 0;
    transition: opacity  0.5s ease-out;
}

.show-button{
    opacity: 1;
    transition: opacity  0.5s ease-out;
}
</style>


// WEBPACK FOOTER //
// src/components/Preview/PreviewStep/Preview/index.vue